import { render, staticRenderFns } from "./index_datas_pagas.vue?vue&type=template&id=227eff0e&"
import script from "./index_datas_pagas.vue?vue&type=script&lang=js&"
export * from "./index_datas_pagas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('227eff0e')) {
      api.createRecord('227eff0e', component.options)
    } else {
      api.reload('227eff0e', component.options)
    }
    module.hot.accept("./index_datas_pagas.vue?vue&type=template&id=227eff0e&", function () {
      api.rerender('227eff0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/pagamento/index_datas_pagas.vue"
export default component.exports